import ApiService from '../api.service'

export default class MaterialService extends ApiService {
  constructor () {
    super()
    this.path = 'material.php'
  }

  materialList (params) {
    const path = `${this.path}`
    return this.http.get(path, {params})
  }

  deletePic(params) {
    const path = `${this.path}?act=delI`
    return this.http.delete(path, params)
  }
}



// WEBPACK FOOTER //
// ./src/service/api/materialService.js